import { ElementClickedEvent } from './events/ElementClickedEvent';
import { PageViewedEvent } from './events/PageViewedEvent';
import { trackEvent } from './trackEvent';

let initAlreadyRan = false;

/**
 * Initialize automatic analytics tracking for GWS-Flows.
 *
 * NOTE: This is a custom implementation for GWS-Flows, NOT the shared
 * "Standard Analytics" package from ZenPayroll's @gusto/instrumentation.
 * The EventEnvelope structure is compatible with ZP's schema for cross-platform
 * analytics, but the implementation is tailored for GWS-Flows' embedded/iframe context.
 *
 * Sets up automatic tracking for:
 * - Page views (initial load + Turbo navigation).
 * - Element clicks (all buttons and links).
 *
 * Should be called once when the application loads.
 */
export function initAnalytics(): void {
  if (initAlreadyRan) {
    return;
  }
  initAlreadyRan = true;

  // Track page views on both initial load and Turbo navigation
  document.addEventListener('turbo:load', () => {
    trackPageView();
  });

  // Track all button and link clicks
  document.addEventListener(
    'click',
    (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const clickable = target.closest('a, button');

      if (clickable) {
        trackEvent(new ElementClickedEvent(), clickable);
      }
    },
    { capture: true },
  );
}

function trackPageView() {
  trackEvent(new PageViewedEvent());
}
